export default "__VITE_ASSET__ebf4cc09__"